import { render } from "./Price.vue?vue&type=template&id=607ce618"
import script from "./Price.vue?vue&type=script&lang=js"
export * from "./Price.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miniapp-property-b2b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/pages/Popup/Price.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "607ce618"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('607ce618', __exports__)) {
    api.reload('607ce618', __exports__)
  }
  
  module.hot.accept("./Price.vue?vue&type=template&id=607ce618", () => {
    api.rerender('607ce618', render)
  })

}


export default __exports__